import '@progress/kendo-ui'
kendo.culture("de-DE");


import { Editor } from "@progress/kendo-vue-editor";
Vue.component('kendo-editor', Editor);

import { Switch } from '@progress/kendo-vue-inputs';
Vue.component('kendo-switch', Switch);

import { DropDownList } from '@progress/kendo-vue-dropdowns';
Vue.component('kendo-dropdownlist', DropDownList);

import { Window } from "@progress/kendo-vue-dialogs";
Vue.component('kendo-window', Window);

import { MultiSelect } from '@progress/kendo-vue-dropdowns';
Vue.component('kendo-multiselect', MultiSelect);

import { ComboBox } from '@progress/kendo-vue-dropdowns';
Vue.component('kendo-combobox', ComboBox);

import { AutoComplete } from '@progress/kendo-vue-dropdowns';
Vue.component('kendo-autocomplete', AutoComplete);

import { TextArea } from '@progress/kendo-vue-inputs';
Vue.component('kendo-textarea', TextArea);

import { Checkbox } from '@progress/kendo-vue-inputs';
Vue.component('kendo-checkbox', Checkbox);

import { TabStrip } from '@progress/kendo-vue-layout';
Vue.component('kendo-tabstrip', TabStrip);

